import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { API } from "../lib/api";
import { useSucursales } from "../lib/useSucursales";
import { Download, BarChart3 } from "lucide-react";
import { toast } from "sonner";

const PERIODOS = [{ id: "dia", label: "Hoy" }, { id: "semana", label: "Últimos 7 días" }, { id: "mes", label: "Este mes" }, { id: "30", label: "Últimos 30 días" }, { id: "90", label: "Últimos 90 días" }];

export default function Reportes() {
  const { setMobileOpen } = useOutletContext();
  const SUCS = [{ code: "todas", name: "Todas las sucursales" }, ...useSucursales().map((s) => ({ code: s.code, name: s.name }))];
  const [suc, setSuc] = useState("todas");
  const [dias, setDias] = useState("semana");
  const [loading, setLoading] = useState(false);

  const descargar = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("pya_token");
      const qs = /^\d+$/.test(dias) ? `dias=${dias}` : `periodo=${dias}`;
      const res = await fetch(`${API}/reportes/semanal?sucursal=${suc}&${qs}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error("No se pudo generar el reporte");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `reporte_${dias}_${suc}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("Reporte descargado");
    } catch (e) { toast.error(e.message); }
    finally { setLoading(false); }
  };

  const select = "rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-[#0A1F44] outline-none focus:border-[#3B82F6]";

  return (
    <>
      <Header title="Reportes" subtitle="Exportá envíos, cobros y liquidaciones" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 max-w-2xl">
        <div className="bg-white rounded-xl border border-[#E2E8F0] p-6 shadow-sm">
          <div className="flex items-center gap-3 mb-5"><div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center"><BarChart3 className="h-5 w-5 text-[#3B82F6]" /></div><div className="font-bold text-[#0A1F44] font-display">Generar reporte CSV</div></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div><label className="text-xs font-semibold text-[#64748B]">Sucursal</label><select className={`${select} w-full`} value={suc} onChange={(e) => setSuc(e.target.value)}>{SUCS.map((s) => <option key={s.code} value={s.code}>{s.name}</option>)}</select></div>
            <div><label className="text-xs font-semibold text-[#64748B]">Período</label><select className={`${select} w-full`} value={dias} onChange={(e) => setDias(e.target.value)} data-testid="reporte-periodo-select">{PERIODOS.map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}</select></div>
          </div>
          <button onClick={descargar} disabled={loading} data-testid="reporte-download-btn" className="mt-5 w-full flex items-center justify-center gap-2 rounded-lg bg-[#0A1F44] hover:bg-[#132D5C] text-white font-semibold py-2.5 text-sm disabled:opacity-60">
            <Download className="h-4 w-4" /> {loading ? "Generando..." : "Descargar reporte"}
          </button>
        </div>
      </main>
    </>
  );
}
